import React from 'react';
import { HashRouter, Routes, Route } from "react-router-dom";
import Navbar from './Components/Navbar/Navbar';
import About2 from './Components/About2';
import Footer from './Components/Footer';
import Gallery from './Components/Gallery/Gallery';
import Homepage from './Components/Homepage';
import Tc from './Components/TC/Tc';
import Inspiration from './Components/Inspiration';
import Login from './Components/Login/Login';

const App = () => {
  return (
    <HashRouter>
        <Navbar/>
        <Routes>
          <Route path='/' element={<Homepage/>} />
          <Route path='/home' element={<Homepage/>} />
          <Route path='/about' element={<About2/>} />
          <Route path='/gallery' element={<Gallery/>}/>
          <Route path='/inspiration' element={<Inspiration/>}/>
          <Route path='/tc' element={<Tc/>}/>
          <Route path='/login' element={<Login/>}/>
        </Routes>
      
        <Footer/>
    </HashRouter>
  );
}

export default App;
